import React from 'react';

import { css } from 'helpers';


/*
 * BulletedList & NumberedList
 */
const listRootClass = css({
  paddingLeft: 'calc(1rem + 8px)',
  // '& > li > ul, & > li > ol': {
  //   paddingLeft: 'calc(1rem + 16px)'
  // },
});
const BulletedList = ({ attributes, children }) => (
  <ul className={listRootClass} {...attributes}>
    {children}
  </ul>
);
const NumberedList = ({ attributes, children }) => (
  <ol className={listRootClass} {...attributes}>
    {children}
  </ol>
);


/*
 * ListItem
 */
const listItemClass = css({
  margin: '2px auto',
  '& p': { margin: 0 },
});
const ListItem = ({ attributes, children }) => (
  <li className={listItemClass} {...attributes}>
    {children}
  </li>
);

export {
  BulletedList,
  NumberedList,
  ListItem,
}



// WEBPACK FOOTER //
// ./src/components/slate/nodes/list.js